// index.ts
import { installExtension } from "@juitnow/lib-fetch-client";
import { BodyBuilder } from "./body-builder.mjs";
import { queryTypedArguments } from "./generated.mjs";
var GraphImpl = class {
  constructor(_http) {
    this._http = _http;
  }
  async request(queryName, fields, variables) {
    const body = new BodyBuilder(queryTypedArguments).withQueryName(queryName).withFields(fields).withVariables(variables).build();
    const response = await this._http.post("/graph/v2", body);
    const json = response.data;
    if (json.errors) {
      const message = String(json.errors[0]?.message || "Unknown GraphQL Error");
      this._http.fail(response.request, response, { message, errors: json.errors });
    }
    return json.data[queryName];
  }
  async orders(filters, fields) {
    return this.request("orders", fields, filters);
  }
  async unrated_orders(filters, fields) {
    return this.request("unrated_orders", fields, filters);
  }
};
installExtension("graphV2", GraphImpl);
//# sourceMappingURL=index.mjs.map
